<template>
  <environment-template
    :excess-shine="excessShine"
    :only-greasy-in-summer="onlyGreasyInSummer"
    :field-errors="fieldErrors"
    @field-change="onFieldChange"
  />
</template>

<script>
import EnvironmentTemplate from '@/modules/questionnaire/components/steps/photo-analysis/skin-oiliness/environment/EnvironmentTemplate';

import { makeStep } from '@/modules/questionnaire/mixins';
import { fieldBuilder } from '@/modules/questionnaire/mixins/makeStep';

const { requiredField } = fieldBuilder;

const FIELDS = [requiredField('excessShine'), requiredField('onlyGreasyInSummer')];

export default {
  name: 'Environment',
  components: { EnvironmentTemplate },
  mixins: [makeStep(FIELDS)],
  watch: {
    excessShine() {
      this.scrollTo('#only-greasy-in-summer');
    },
    onlyGreasyInSummer() {
      this.showNextStep();
    }
  }
};
</script>
